import { render, staticRenderFns } from "./payList.vue?vue&type=template&id=33bc22e4&scoped=true&"
import script from "./payList.vue?vue&type=script&lang=js&"
export * from "./payList.vue?vue&type=script&lang=js&"
import style0 from "./payList.vue?vue&type=style&index=0&id=33bc22e4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bc22e4",
  null
  
)

export default component.exports